import Instructions from './Instructions';
import IntlWrapper from 'components/layout/intlWrapper';
import MergePage from './Merge';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import Report from './Report';
import routeUtils from 'util/routeUtils';
import toolFlow from 'helpers/toolFlow';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {getDuplicateAccounts} from 'api/dataCleanup';
import {Header} from 'components/layout';
import {router, events} from 'lib';

const STORAGE_KEY = 'MERGED-IDS';

// Register in router
let render = (container, params) => {
  console.info('[UI.page.tools.accounts.find-replace] rendering page');
  ReactDOM.render(<IntlWrapper><WrapperMergeContainer page={params.page || 0}/></IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.customer] register route');
router.rr.add([{path: 'tools/accounts/merge/:page', handler: routeUtils.requireAuth(render)}]);

class Merge extends React.Component {
  static displayName = 'Merge';

  static propTypes = {
    setPage: PropTypes.func.isRequired,
    View: PropTypes.any.isRequired,
  };

  state = {
    id1: null,
    id2: null,
    results: undefined,
    total: 0,
  };

  getResults = ({page = 1, sortKey = 'score', sortDirection = 'desc', showIgnored = false, search = ''}) => {
    getDuplicateAccounts({page, sortKey, sortDirection, hideIgnored: !showIgnored, search})
      .then(({results, total}) => {
        let filters = JSON.parse(localStorage.getItem(STORAGE_KEY));

        filters = filters || [];
        filters = filters.filter(x => moment.utc(x.exp).isAfter(moment.utc()));

        results = results.filter(x => !filters.find(y => y.id === x.ID1) && !filters.find(y => y.id === x.ID2));

        localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));

        this.setState({
          results,
          total,
        });
      });
  };

  cancel = () => {
    this.setState({
      id1: null,
      id2: null,
    });
    this.props.setPage(1);
  };

  compare = (id1, id2) => {
    this.setState({id1, id2});
    this.props.setPage(2);
  };

  mergeComplete = () => {
    let results = this.state.results;

    let filters = JSON.parse(localStorage.getItem(STORAGE_KEY));

    filters = filters || [];
    filters = filters.filter(x => moment.utc(x.exp).isAfter(moment.utc()));

    filters.push({id: this.state.id1, exp: moment.utc().add(5, 'minutes')});
    filters.push({id: this.state.id2, exp: moment.utc().add(5, 'minutes')});

    localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));

    results = results.filter(x => !filters.find(y => y.id === x.ID1) && !filters.find(y => y.id === x.ID2));

    this.setState({
      results,
      id1: null,
      id2: null,
      total: this.state.total - 1,
    });
    this.props.setPage(1);
  };

  reloadReport = () => {
    this.setState({
      id1: null,
      id2: null,
      results: undefined,
      total: 0,
    });
    this.props.setPage(1);
  };

  render() {
    let {View} = this.props;
    let {formatMessage} = this.props.intl;

    return (
      <div className='container'>
        <Header mainTitle={formatMessage({id: 'general.accounts'})}
                subTitle={formatMessage({id: 'tools.merge.duplicate.accounts'})} mainTitleReturn='#tools/accounts'/>
        <View compare={this.compare} id1={this.state.id1} id2={this.state.id2} cancel={this.cancel}
              results={this.state.results}
              getResults={(...args) => this.getResults(...args)} mergeComplete={this.mergeComplete}
              total={this.state.total}
              reloadReport={this.reloadReport}/>
      </div>
    );
  }
}

const MergeContainer = toolFlow(Merge, Instructions, Report, MergePage);

let WrapperMergeContainer = injectIntl(MergeContainer);
